import React, { useState, useEffect } from 'react';
import { styled, alpha } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import SummarizeIcon from '@mui/icons-material/Summarize';
import VisibilityIcon from '@mui/icons-material/Visibility';
import api from '../../API/api';


import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Loader from './loader';


const StyledMenu = styled((props) => (
    <Menu
        elevation={0}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
        }}
        transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
        }}
        {...props}
    />
))(({ theme }) => ({
    '& .MuiPaper-root': {
        borderRadius: 6,
        marginTop: theme.spacing(1),
        minWidth: 180,
        color:
            theme.palette.mode === 'light' ? 'rgb(55, 65, 81)' : theme.palette.grey[300],
        boxShadow:
            'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
        '& .MuiMenu-list': {
            padding: '4px 0',
        },
        '& .MuiMenuItem-root': {
            '& .MuiSvgIcon-root': {
                fontSize: 18,
                color: theme.palette.text.secondary,
                marginRight: theme.spacing(1.5),
            },
            '&:active': {
                backgroundColor: alpha(
                    theme.palette.primary.main,
                    theme.palette.action.selectedOpacity,
                ),
            },
        },
    },
}));

export default function DocumentViewMenu(props) {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };


    const [modalData, setModalData] = useState({
        type: '',
        data: ''
    });
    const handleView = (data, type) => {

        switch (type) {
            case 'ID Proof':
                // console.log('ID Proof');
                setModalData({
                    type: type,
                    data: data.adproofimage
                })
                break;

            case '10th Marksheet':
                // console.log('10th Marksheet');
                setModalData({
                    type: type,
                    data: data.tenmarksimage
                })
                break;
            case '10th Admit':
                // console.log('10th Admit');
                setModalData({
                    type: type,
                    data: data.admitimage
                })
                break;
            // case 'Final Year Document':
            //     console.log('Final Year Document');
            //     setModalData({
            //         type: type,
            //         data: data.adproofimage
            //     })
            //     break;
            case '12th Marksheet':
                // console.log('12th Marksheet');
                setModalData({
                    type: type,
                    data: data.twelvemarksimage
                })
                break;

        }



        handleClickOpenModal()
        // console.log(data);
        // console.log(type);



        // setModalData({
        //     type: type,
        //     data: data.adproofimage
        // })
    }


    const [openModal, setOpenModal] = React.useState(false);

    const handleClickOpenModal = () => {
        setOpenModal(true);
    };

    const handleCloseModal = () => {
        setOpenModal(false);
    };

    const [load, setLoad] = useState(false);

    const modal = () => {
        return (
            <>
                {load && <Loader />}
                <div>
                    <Dialog fullWidth={true} maxWidth='md' open={openModal} onClose={handleCloseModal}>
                        <DialogTitle>{modalData.type}</DialogTitle>
                        <DialogContent>
                            {/* <DialogContentText>
                                To subscribe to this website, please enter your email address here. We
                                will send updates occasionally.
                            </DialogContentText> */}
                            <img src={`${process.env.REACT_APP_BACKEND}uploaded_images/${modalData.data}`} alt="" />
                            {/* <img src={`https://cpmsc.com/public/uploaded_images/${modalData.data}`} alt="" /> */}
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleCloseModal}>Cancel</Button>
                            <a href={`${process.env.REACT_APP_BACKEND}uploaded_images/${modalData.data}`} download>Download</a>
                        </DialogActions>
                    </Dialog>
                </div>
            </>
        )
    }


    return (
        <>
            <div>
                <Button
                    id="demo-customized-button"
                    aria-controls={open ? 'demo-customized-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? 'true' : undefined}
                    // variant="contained"
                    disableElevation
                    onClick={handleClick}
                    endIcon={<SummarizeIcon />}
                >
                    {/* Options */}
                </Button>


                <StyledMenu
                    id="demo-customized-menu"
                    MenuListProps={{
                        'aria-labelledby': 'demo-customized-button',
                    }}
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                >
                    {/* <MenuItem onClick={handleClose} disableRipple>
          <EditIcon />
          Edit
        </MenuItem> */}

                    <MenuItem onClick={() => handleView(props.data, 'ID Proof')} disableRipple>
                        <VisibilityIcon />
                        Id Proof
                    </MenuItem>

                    <MenuItem onClick={() => handleView(props.data, '10th Marksheet')} disableRipple>
                        <VisibilityIcon />
                        10th Marksheet
                    </MenuItem>

                    <MenuItem onClick={() => handleView(props.data, '10th Admit')} disableRipple>
                        <VisibilityIcon />
                        10th Admit
                    </MenuItem>

                    {/* <MenuItem onClick={() => handleView(props.data, 'Final Year Document')} disableRipple>
                        <VisibilityIcon />
                        Final Year Document
                    </MenuItem> */}
                    <MenuItem onClick={() => handleView(props.data, '12th Marksheet')} disableRipple>
                        <VisibilityIcon />
                        12th Marksheet
                    </MenuItem>


                    {/* <Divider sx={{ my: 0.5 }} />
                <MenuItem onClick={handleClose} disableRipple>
                    <ArchiveIcon />
                    Archive
                </MenuItem>
                <MenuItem onClick={handleClose} disableRipple>
                    <MoreHorizIcon />
                    More
                </MenuItem> */}
                </StyledMenu>
            </div>

            {modal()}
        </>
    );
}